/*
 */
export function bindEvent(
    element: EventTarget,
    event: keyof HTMLElementEventMap,
    handler
) {
    element.addEventListener(event, handler, false);
    return () => {
        element.removeEventListener(event, handler, false);
    };
}

/*
 */
export function bindEventOnce(
    element: EventTarget,
    event: keyof HTMLElementEventMap,
    handler
) {
    let unbind;
    return (unbind = bindEvent(element, event, e => {
        unbind();
        handler(e);
    }));
}
